import React from 'react';
import { AnalyticsEventLocation, Project, StructuredProject } from '@mb/lib';
import { ProductSearchMaterial } from '@productSearch/types';
import { CardInfoLevel } from 'components/Elements/GridTypeSelector/GridTypeSelector.types';
import { useIntl } from 'react-intl';
import { ResultCard } from './ResultCard';
import { handleMiniPdpVariantClickDataLayer } from '../../helpers/analytics';
import { ProductDetails } from '../../types/product';

export interface CardWrapperProps {
  cardIndex: number;
  groupFinishes: ProductSearchMaterial[];
  clickedProductGridIndex?: number;
  clickedProductRequestId?: string;
  activeProduct: ProductDetails;
  projects: StructuredProject[];
  currentProjectData: StructuredProject;
  cartItemsIds: string[];
  wasModalTriggered: boolean;
  currentMaterialId?: string;
  isColorways?: boolean;
  loadingCartIds?: string[];
  onProductClick: (material: ProductSearchMaterial) => void;
  onCreateProjectClick?: (params: any) => void;
  onProjectClick?: (id: string, options: any) => void;
  onAddToCart: (material?: ProductSearchMaterial, isFinish?: boolean) => void;
  onProjectCreate?: (project: Project) => void;
  onProjectSelect?: (projectId: number) => void;
}

export const CardWrapper: React.FC<CardWrapperProps> = ({
  cardIndex,
  groupFinishes = [],
  clickedProductGridIndex,
  activeProduct,
  projects,
  currentProjectData,
  cartItemsIds,
  wasModalTriggered,
  onProductClick,
  onAddToCart,
  currentMaterialId,
  isColorways,
  loadingCartIds,
}) => {
  const intl = useIntl();
  let material = groupFinishes?.[cardIndex];

  if (material == null) {
    return null;
  }

  material = {
    ...material,
    gridIndex: clickedProductGridIndex,
    associatedItem: activeProduct?.nameLabel,
  };

  const handleProductClick = (material: ProductSearchMaterial) => {
    handleMiniPdpVariantClickDataLayer(material);
    onProductClick?.(material);
  };

  return (
    <ResultCard
      loadingCartIds={loadingCartIds}
      isMiniPDPFinish={!isColorways}
      isColorway={isColorways}
      material={material}
      index={cardIndex}
      infoMode={CardInfoLevel.LESS_INFO}
      projects={projects}
      selectedProject={currentProjectData}
      onProductClick={handleProductClick}
      cartItemsIds={cartItemsIds}
      relatedProductInfo={{
        title: `${activeProduct?.brandLabel}: ${activeProduct?.nameLabel}`,
        id: activeProduct?.entityId,
      }}
      shouldTriggerRecModal={!wasModalTriggered}
      onAddToCart={onAddToCart}
      itemListId="mini_pdp"
      itemListName="Mini PDP"
      analyticsEventLocation={AnalyticsEventLocation.MINI_PDP}
      intl={intl}
      isOutlined={String(currentMaterialId) === String(material.entityId)}
    />
  );
};
